import { Autocomplete, AutocompleteChangeDetails, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { CompanyNamePICSelectorSelector, setCompanyNamePICSearchResults } from './reducers/CompanyNamePICSelectorReducer';
import CompanyNamePICApi, { SearchCompanyNamePICNameParam } from '../CompanyNamePIC/api/CompanyNamePICApi';
import CompanyNamePICModel from '../CompanyNamePIC/models/CompanyNamePICModel';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';

interface CompanyNamePICSelectorProps {
    selectedId: string,
    label: string,
    className?: string,
    onChange?: (selectedItem: CompanyNamePICModel | null) => void,
}

const CompanyNamePICSelector: React.FunctionComponent<CompanyNamePICSelectorProps> = (props) => {
    const dispatch = useDispatch();
    const companyNamePICSelectorData = useSelector(CompanyNamePICSelectorSelector);
    const textboxRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        if (companyNamePICSelectorData.searchResults.length > 0) {
            return;
        }
        
        dispatch(showLoading(true));
        CompanyNamePICApi.GetAll()
            .then((response: BaseResponse<CompanyNamePICModel[]>) => {
                if (response.success) {
                    dispatch(setCompanyNamePICSearchResults(response.data))
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            })
    }, []);

    const getById = (id: string) => {
        return _.find(companyNamePICSelectorData.searchResults, (item) => {
            return item.id === id;
        });
    }

    return (
        <>
            <Autocomplete
                fullWidth
                className={props.className ? props.className : ""}
                value={getById(props.selectedId)}
                options={companyNamePICSelectorData.searchResults}
                renderInput={(params) => <TextField {...params} label={props.label} inputRef={textboxRef} />}
                getOptionLabel={(option: CompanyNamePICModel) => {
                    return option.companyName + " - " + option.pic;
                }}
                onChange={(event: React.SyntheticEvent, value: CompanyNamePICModel | null, reason: string, details?: AutocompleteChangeDetails<CompanyNamePICModel> | undefined) => {
                    if (props.onChange) {
                        props.onChange(value);
                    }
                }}
            />
        </>
    )
};

export default CompanyNamePICSelector;